import { render, staticRenderFns } from "./productsevaluatereal.vue?vue&type=template&id=01296b53&"
import script from "./productsevaluatereal.vue?vue&type=script&lang=js&"
export * from "./productsevaluatereal.vue?vue&type=script&lang=js&"
import style0 from "./productsevaluatereal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports